import { DepartmentState, DepartmentTypes } from '../actions/departments/departments.d';
import {
  FETCH_DEPARTMENTS_COMPLETED,
  FETCH_DEPARTMENTS_ERROR,
  FETCH_DEPARTMENTS_STARTED,
  UPDATE_DEPARTMENTS_CURRENT_PAGE,
  UPDATE_DEPARTMENTS_PAGE_SIZE,
  ADD_DEPARTMENT_SEARCH,
  CLEAR_DEPARTMENT_SEARCH,
  UPDATE_DEPARTMENTS_COLUMN_SORT,
  CLEAR_DEPARTMENT_COLUMN_SORT,
} from 'redux/actionTypes/departments';

const INITIAL_STATE: DepartmentState = {
  data: [],
  error: false,
  submitted: false,
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    nextPage: 0,
    prevPage: null,
    isFirstPage: false,
    isLastPage: false,
    startAt: null,
    endAt: null,
  },
  q: '',
  sorted: [],
};

function departmentsReducer(state = INITIAL_STATE, action: DepartmentTypes): DepartmentState {
  switch (action.type) {
    case FETCH_DEPARTMENTS_STARTED: {
      return {
        ...state,
        submitted: true,
      };
    }

    case FETCH_DEPARTMENTS_COMPLETED: {
      return {
        ...state,
        ...action.payload,
        submitted: false,
      };
    }

    case FETCH_DEPARTMENTS_ERROR: {
      return {
        ...state,
        error: true,
        submitted: false,
      };
    }

    case UPDATE_DEPARTMENTS_CURRENT_PAGE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.currentPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case UPDATE_DEPARTMENTS_PAGE_SIZE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.perPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case ADD_DEPARTMENT_SEARCH: {
      return {
        ...state,
        q: action.payload,
      };
    }

    case CLEAR_DEPARTMENT_SEARCH: {
      return {
        ...state,
        q: '',
      };
    }

    case UPDATE_DEPARTMENTS_COLUMN_SORT: {
      return {
        ...state,
        sorted: action.payload,
      };
    }

    case CLEAR_DEPARTMENT_COLUMN_SORT: {
      return {
        ...state,
        sorted: [],
      };
    }

    default:
      return state;
  }
}

export default departmentsReducer;
